// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs'
import Turbolinks from 'turbolinks'
import * as ActiveStorage from '@rails/activestorage'
import 'channels'

Rails.start()
Turbolinks.start()
ActiveStorage.start()

import 'jquery-ui';
$.widget.bridge('uibutton', $.ui.button);
$.widget.bridge('uitooltip', $.ui.tooltip);

import 'bootstrap';
import '../stylesheets/application';
window.$ = jQuery;
window.jQuery = jQuery;
//global.$ = jQuery;
//import $ from 'jquery';

// FullCalender
import '@fullcalendar/common/main.css'
import '@fullcalendar/daygrid/main.css'
import '@fullcalendar/list/main.css'

// SELECT2
import 'select2'
import 'select2/dist/css/select2.css'

// Summernote
require("summernote/dist/summernote-lite.js");
require("summernote/dist/summernote-lite.css");
require("summernote/dist/lang/summernote-ja-JP.js");

// MultiSelect
//import 'multiselect';
//require("multiselect");
require("multiselect/js/jquery.multi-select.js");
require("multiselect/css/multi-select.css");

// flatpickr (DatePicker)
import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/confetti.css';
import 'flatpickr/dist/l10n/ja.js';
import 'flatpickr/dist/plugins/monthSelect/style.css';

// chartkick & chart.js
import "chartkick/chart.js"
//require("chartkick");
//require("chart.js");

// HTMLからコントローラ名取得
var controller = $('body').data('controller');
var action = $('body').data('action');

// ローディング非表示
window.stopload = function() {
  // ローディング画面 非表示
  $('#loading').hide();
}

// 検索欄 企業名検索submit
window.searchCorporatesSubmit = function() {
  $("#sc_corporate_id").val( $("#corporate_id").val() );
  $("#sc_corporate_name").val( $("#corporate_name").val() );

  // Remote Submit
  Rails.fire( $("#search_corporates_form")[0], "submit" );
}

// 検索欄 手続き分類 変更submit
window.searchProcedureTypeChangeSubmit = function() {
  $("#sptc_procedure_type_id").val( $("#procedure_type_id").val() );
  $("#sptc_procedure_id").val( $("#procedure_id").val() );

  // Remote Submit
  Rails.fire( $("#search_procedure_type_change_form")[0], "submit" );
}

// 検索欄 手続き等 変更submit
window.searchProcedureChangeSubmit = function() {
  $("#spc_procedure_id").val( $("#procedure_id").val() );

  // Remote Submit
  Rails.fire( $("#search_procedure_change_form")[0], "submit" );
}

// ユーザーモーダルsubmit
window.userModalSubmit = function( operation, user_id ) {
  $("#um_operation").val( operation );
  $("#um_user_id").val( user_id );

  Rails.fire( $("#user_modal_form")[0], "submit" );
}

// ユーザー情報操作submit
window.userOperationSubmit = function() {

  Rails.fire( $("#user_form")[0], "submit" );
}

// ユーザーパスワード自動変更
window.userPasswdAutoGenerateSubmit = function() {
  alertify.confirm("パスワードを自動変更します", function (e) {
    if (e) {
        // user clicked "ok"
        $("#user_operation").val( "pwchg_generate" );
        // Remote Submit
        Rails.fire( $("#user_form")[0], "submit" );
    } else {
        // user clicked "cancel"
    }
  });
}

// ユーザーパスワードリセット
window.userPasswdResetSubmit = function(id, name) {
  alertify.confirm("["+name+"] のパスワードをリセット・自動生成し、新パスワードをメール送信します", function (e) {
    if (e) {
        // user clicked "ok"
        $("#upr_id").val( id );
        // Remote Submit
        Rails.fire( $("#user_passwd_reset_form")[0], "submit" );
    } else {
        // user clicked "cancel"
    }
  });
}
